export const PROFILE_SET_PROFILE = 'PROFILE_SET_PROFILE';
export const PROFILE_DELETE_PAYMENT_SOURCE = 'PROFILE_DELETE_PAYMENT_SOURCE';
export const PROFILE_SET_DEFAULT_PAYMENT_SOURCE = 'PROFILE_SET_DEFAULT_PAYMENT_SOURCE';
export const PROFILE_RESET_PROFILE = 'PROFILE_RESET_PROFILE';
export const PROFILE_TOGGLE_LOADING = 'PROFILE_TOGGLE_LOADING';
